import React from "react";
import AudioPlayer from "components/AudioPlayer";
import VideoPlayer from "components/VideoPlayer";
import ImageContainer from "components/ImageContainer/ImageContainer";
import classNames from "classnames";
import MediaPreview from "components/MediaPreview/MediaPreview";

export default ({ listTask }) => {
  return (
    <div className="post-content">
      {listTask.description && (
        <div
          className={classNames({
            textContent: true,
            completeTaskDescription: listTask.status_id === 2 ? true : false,
            customScrollArea: true,
          })}
          style={{ maxHeight: "200px", overflow: "auto" }}
        >
          {listTask.description}
        </div>
      )}
      {listTask?.media_type_id === 3 && (
        <VideoPlayer
          src={listTask?.media}
          mediaCaptions={listTask?.media_captions?.vtt}
        />
      )}
      {listTask?.media_type_id === 4 && (
        <div>
          <AudioPlayer src={listTask?.media} />
        </div>
      )}
      {listTask?.media_type_id === 2 && (
        <MediaPreview attachment={listTask?.media} type={listTask?.media_type}>
          <ImageContainer
            src={listTask?.media}
            thumb={listTask?.media}
            alt={listTask?.media_type}
          />
        </MediaPreview>
      )}
    </div>
  );
};
